import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserDetailPipe, UserPhotoPipe } from '../pipes/common.pipe';


/**
 * 
 */
const getBooleanPipeTemplate = (dataItem: any, column: any) => {
    const label = dataItem[column.field] ? column.template.onLabel : column.template.offLabel;
    let disabledClass: string;

    if (column.template.field && column.template.operation) {
        const check = dataItem[column.template.field];
        const isDisabled = column.template.operation === 'equals' ?
            check : !check;
        disabledClass = isDisabled ? "disabled" : "";
    }
    return `<span class='${disabledClass}'>${label}</span>`;
}


/**
 * 
 */
const getActionLinkPipeTemplate = (dataItem: any, column: any) => {
    return `<div class="k-link mail-link">${dataItem[column.field]}</div>`;
}


/**
 * 
 */
const getEmailPipeTemplate = (dataItem: any, column: any) => {
    const addr: string = dataItem[column.field] ? dataItem[column.field] : "";
    return `<a class="k-link mail-link" href='mailto:${addr}'>${addr}</a>`;

}


/**
 * 
 */
const getLinkPipeTemplate = (dataItem: any, column: any) => {
    let link: string = dataItem[column.field] ? dataItem[column.field] : "";
    if (link && !link.startsWith('http')) link = "http://" + link;
    return `<a class="k-link mail-link" href='${link}' target='_blank'>${link}</a>`;
}


/**
 * 
 */
const getDatePipeTemplate = (dataItem: any, column: any) => {
    let response;
    if (dataItem[column.field] === "" || dataItem[column.field] === null || !dataItem[column.field]) {
        response = "";
    }
    else {
        const _timeStamp: string = dataItem[column.field];
        const _format: string = column.template.dateFormat ? column.template.dateFormat : 'short';
        const _date = new DatePipe('en-US')
            .transform(_timeStamp, _format);
        response = `${_date}`;
    }
    return response;
}


/**
 * 
 */
const getUserPhotoPipeTemplate = (dataItem: any, column: any) => {
    return new UserPhotoPipe()
        .transform(dataItem, column);
}


/**
 * 
 */
const getUserDetailPipeTemplate = (dataItem: any, column: any) => {
    return new UserDetailPipe()
        .transform(dataItem, column);
}


/**
 * 
 */
const getCustomStylePipeTemplate = (dataItem: any, column: any) => {
    let response;
    let val: string = dataItem[column.field];
    if (!val) {
        val = dataItem;
        column.field.split('.').forEach(f => val ? val = val[f] : null);
    }
    if (column.class) {
        response = `<div class="column.class">${val}</div>`;
    }
    else if (column.template.setClass) {
        const className = column.template.setClass(dataItem);
        response = `<div class="${className}">${val}</div>`
    }
    else {
        response = `<div>${val}</div>`
    }
    return response;
}


/**
 * 
 */
const getDropdownPipeTemplate = (dataItem: any, column: any) => {
    const _field = column.textField ? column.textField : column.field;
    let _value = dataItem[_field];
    if (!_value) _value = '';
    return `${_value}`;
}


/**
 * 
 * @param dataItem 
 * @param column 
 * If attachment doesn't exist it shouldn't insert img tag.
 */
const getAttachmentPipeTemplate = (dataItem: any, column: any) => {
    const imageSize = (column.template.width && column.template.height) ?
        ` width="${column.template.width}" height="${column.template.height}"` :
        ` width="32" height="32"`;
    if (dataItem[column.field]) {
        return `<img src="${dataItem[column.field]}"${imageSize} />`;
    }
    else {
        return ``;
    }
}


/**
 * 
 */
const GridPipeTemplateType = {
    'attachment': getAttachmentPipeTemplate,
    'boolean': getBooleanPipeTemplate,
    'email': getEmailPipeTemplate,
    'action-link': getActionLinkPipeTemplate,
    'link': getLinkPipeTemplate,
    'date': getDatePipeTemplate,
    'userPhoto': getUserPhotoPipeTemplate,
    'userDetail': getUserDetailPipeTemplate,
    'customStyle': getCustomStylePipeTemplate,
    'combobox': getDropdownPipeTemplate,
    'multiselect': getDropdownPipeTemplate,
    'default': (dataItem, column) => dataItem[column.field]
}


/**
 * 
 */
@Pipe({ name: 'columnTemplate' })
export class ColumnTemplatePipe implements PipeTransform {
    transform(column: any, dataItem: any) {
        return (GridPipeTemplateType[column.template.type] || GridPipeTemplateType['default'])(dataItem, column);
    }
}
